<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
    <portal-target name="modal-root"></portal-target>
  </div>
</template>

<script>
import Vue from "vue";
import themeConfig from "@/../themeConfig.js";
import * as filters from "./filter.js";
import defaultHttpClient from "@/http/default/index";
import aiseaHttpClient from "@/http/aisea/index";
import rgHttpClient from "@/http/radar-grid/index";
import aiseaLocalStorageDb from "@/db/aisea/index";
import secureDataflowLocalStorageDb from "@/db/secure-dataflow/index";
import operationLocalStorageDb from "@/db/operation";
import validatioCcustomRules from "@/utils/validatioCcustomRules/index";

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_SIZE", {
        width: window.innerWidth,
        height: window.innerHeight,
      });

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
    handleOrientationChange() {
      this.$store.commit("UPDATE_DEVICE_INFO");
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_SIZE", {
      width: window.innerWidth,
      height: window.innerHeight,
    });
    this.$store.commit("UPDATE_DEVICE_INFO");

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  async created() {
    // http初期化
    defaultHttpClient.init();
    aiseaHttpClient.init();
    rgHttpClient.init();

    // db初期化
    aiseaLocalStorageDb.init();
    secureDataflowLocalStorageDb.init();
    operationLocalStorageDb.init();

    // カスタムバリデーション初期化
    validatioCcustomRules.init();

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("orientationchange", this.handleOrientationChange);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
  },
};
</script>
